const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 57,
    viewBox: "0 0 169 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 168.482,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_730_200069)",
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    width: 167.482,
    height: 31,
    rx: 15.5,
    stroke: "url(#paint1_linear_730_200069)",
    strokeOpacity: 0.35,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.54 36.9C11.74 36.62 11.9 36.2867 12.02 35.9C12.14 35.5 12.2 35.08 12.2 34.64V25.36C12.2 24.92 12.14 24.5067 12.02 24.12C11.9 23.72 11.74 23.38 11.54 23.1V23H20.96L21.42 26.56H21.22C20.9267 25.88 20.6067 25.32 20.26 24.88C19.9133 24.44 19.4667 24.0933 18.92 23.84C18.3733 23.5867 17.6933 23.46 16.88 23.46H14.6V29.7H16.82C17.5133 29.7 18.0533 29.5333 18.44 29.2C18.84 28.8533 19.12 28.38 19.28 27.78H19.48V32.08H19.28C19.12 31.48 18.84 31.0133 18.44 30.68C18.0533 30.3333 17.5133 30.16 16.82 30.16H14.6V36.54H17.34C18.1533 36.54 18.8333 36.4133 19.38 36.16C19.9267 35.9067 20.3733 35.56 20.72 35.12C21.0667 34.68 21.3867 34.12 21.68 33.44H21.88L21.42 37H11.54V36.9ZM24.1377 36.9C24.3377 36.62 24.4977 36.2867 24.6177 35.9C24.7377 35.5 24.7977 35.08 24.7977 34.64V25.36C24.7977 24.92 24.7377 24.5067 24.6177 24.12C24.4977 23.72 24.3377 23.38 24.1377 23.1V23H27.8577V23.1C27.6577 23.38 27.4977 23.72 27.3777 24.12C27.2577 24.5067 27.1977 24.92 27.1977 25.36V36.54H29.7377C30.551 36.54 31.2243 36.4133 31.7577 36.16C32.3043 35.9067 32.751 35.56 33.0977 35.12C33.4443 34.6667 33.771 34.08 34.0777 33.36H34.2777L33.8177 37H24.1377V36.9ZM35.7792 36.9C35.9792 36.62 36.1392 36.2867 36.2592 35.9C36.3792 35.5 36.4392 35.08 36.4392 34.64V25.36C36.4392 24.92 36.3792 24.5067 36.2592 24.12C36.1392 23.72 35.9792 23.38 35.7792 23.1V23H39.4592V23.1C39.2592 23.38 39.0992 23.72 38.9792 24.12C38.8592 24.5067 38.7992 24.92 38.7992 25.36V34.64C38.7992 35.08 38.8592 35.5 38.9792 35.9C39.0992 36.2867 39.2592 36.62 39.4592 36.9V37H35.7792V36.9ZM45.6752 36.9C45.8752 36.62 46.0352 36.2867 46.1552 35.9C46.2752 35.5 46.3352 35.08 46.3352 34.64V23.46H45.3352C44.6418 23.46 44.0352 23.5933 43.5152 23.86C43.0085 24.1133 42.5752 24.4733 42.2152 24.94C41.8685 25.4067 41.5418 25.9867 41.2352 26.68H41.0352L41.4952 23H53.5952L54.0352 26.68H53.8352C53.5418 26 53.2152 25.4267 52.8552 24.96C52.5085 24.48 52.0752 24.1133 51.5552 23.86C51.0485 23.5933 50.4485 23.46 49.7552 23.46H48.7352V34.64C48.7352 35.08 48.7952 35.5 48.9152 35.9C49.0352 36.2867 49.1952 36.62 49.3952 36.9V37H45.6752V36.9ZM55.583 36.9C55.783 36.62 55.943 36.2867 56.063 35.9C56.183 35.5 56.243 35.08 56.243 34.64V25.36C56.243 24.92 56.183 24.5067 56.063 24.12C55.943 23.72 55.783 23.38 55.583 23.1V23H65.003L65.463 26.56H65.263C64.9696 25.88 64.6496 25.32 64.303 24.88C63.9563 24.44 63.5096 24.0933 62.963 23.84C62.4163 23.5867 61.7363 23.46 60.923 23.46H58.643V29.7H60.863C61.5563 29.7 62.0963 29.5333 62.483 29.2C62.883 28.8533 63.163 28.38 63.323 27.78H63.523V32.08H63.323C63.163 31.48 62.883 31.0133 62.483 30.68C62.0963 30.3333 61.5563 30.16 60.863 30.16H58.643V36.54H61.383C62.1963 36.54 62.8763 36.4133 63.423 36.16C63.9696 35.9067 64.4163 35.56 64.763 35.12C65.1096 34.68 65.4296 34.12 65.723 33.44H65.923L65.463 37H55.583V36.9Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.242 52.2492H86.0911H81.1112C80.9828 52.2492 80.8697 52.1682 80.8272 52.0493C80.8203 52.0301 80.8182 52.0176 80.8174 51.9971C80.7916 51.3575 80.2145 37.4031 78.6909 29.7957C77.0934 21.8196 72.6918 9.91759 72.5663 9.57898C72.5625 9.56885 72.5621 9.56632 72.5602 9.55654L72.5599 9.55488C72.5366 9.43142 72.5925 9.30558 72.7012 9.24033L73.0141 9.05264C73.1537 8.96887 73.3346 9.01095 73.4229 9.14774L80.5933 20.2549C80.735 20.4743 81.0695 20.4224 81.1381 20.1704L85.8041 3.0161C85.8845 2.72046 86.3033 2.7189 86.3859 3.01394L91.1919 20.1782C91.262 20.4287 91.595 20.479 91.7361 20.2605L98.9101 9.14774C98.9985 9.01095 99.1794 8.96887 99.319 9.05264L99.6318 9.24033C99.7407 9.30567 99.7965 9.43176 99.773 9.55538L99.7726 9.55749C99.7709 9.56654 99.7705 9.5689 99.7669 9.57857C99.6462 9.90776 95.2859 21.8189 93.7175 29.7957C92.2218 37.4025 91.6904 51.3467 91.6663 51.9964C91.6656 52.0171 91.6635 52.0303 91.6564 52.0498C91.6137 52.1684 91.5007 52.2492 91.3725 52.2492H86.242Z",
    fill: "url(#paint2_linear_730_200069)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.242 52.2492H86.0911H81.1112C80.9828 52.2492 80.8697 52.1682 80.8272 52.0493C80.8203 52.0301 80.8182 52.0176 80.8174 51.9971C80.7916 51.3575 80.2145 37.4031 78.6909 29.7957C77.0934 21.8196 72.6918 9.91759 72.5663 9.57898C72.5625 9.56885 72.5621 9.56632 72.5602 9.55654L72.5599 9.55488C72.5366 9.43142 72.5925 9.30558 72.7012 9.24033L73.0141 9.05264C73.1537 8.96887 73.3346 9.01095 73.4229 9.14774L80.5933 20.2549C80.735 20.4743 81.0695 20.4224 81.1381 20.1704L85.8041 3.0161C85.8845 2.72046 86.3033 2.7189 86.3859 3.01394L91.1919 20.1782C91.262 20.4287 91.595 20.479 91.7361 20.2605L98.9101 9.14774C98.9985 9.01095 99.1794 8.96887 99.319 9.05264L99.6318 9.24033C99.7407 9.30567 99.7965 9.43176 99.773 9.55538L99.7726 9.55749C99.7709 9.56654 99.7705 9.5689 99.7669 9.57857C99.6462 9.90776 95.2859 21.8189 93.7175 29.7957C92.2218 37.4025 91.6904 51.3467 91.6663 51.9964C91.6656 52.0171 91.6635 52.0303 91.6564 52.0498C91.6137 52.1684 91.5007 52.2492 91.3725 52.2492H86.242Z",
    fill: "url(#paint3_linear_730_200069)",
    fillOpacity: 0.85,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.242 52.2492H86.0911H81.1112C80.9828 52.2492 80.8697 52.1682 80.8272 52.0493C80.8203 52.0301 80.8182 52.0176 80.8174 51.9971C80.7916 51.3575 80.2145 37.4031 78.6909 29.7957C77.0934 21.8196 72.6918 9.91759 72.5663 9.57898C72.5625 9.56885 72.5621 9.56632 72.5602 9.55654L72.5599 9.55488C72.5366 9.43142 72.5925 9.30558 72.7012 9.24033L73.0141 9.05264C73.1537 8.96887 73.3346 9.01095 73.4229 9.14774L80.5933 20.2549C80.735 20.4743 81.0695 20.4224 81.1381 20.1704L85.8041 3.0161C85.8845 2.72046 86.3033 2.7189 86.3859 3.01394L91.1919 20.1782C91.262 20.4287 91.595 20.479 91.7361 20.2605L98.9101 9.14774C98.9985 9.01095 99.1794 8.96887 99.319 9.05264L99.6318 9.24033C99.7407 9.30567 99.7965 9.43176 99.773 9.55538L99.7726 9.55749C99.7709 9.56654 99.7705 9.5689 99.7669 9.57857C99.6462 9.90776 95.2859 21.8189 93.7175 29.7957C92.2218 37.4025 91.6904 51.3467 91.6663 51.9964C91.6656 52.0171 91.6635 52.0303 91.6564 52.0498C91.6137 52.1684 91.5007 52.2492 91.3725 52.2492H86.242Z",
    fill: "#FFC632",
    style: {
      fill: "#FFC632",
      fill: "color(display-p3 1.0000 0.7748 0.1958)",
      fillOpacity: 1,
      mixBlendMode: "color"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.242 52.2492H86.0911H81.1112C80.9828 52.2492 80.8697 52.1682 80.8272 52.0493C80.8203 52.0301 80.8182 52.0176 80.8174 51.9971C80.7916 51.3575 80.2145 37.4031 78.6909 29.7957C77.0934 21.8196 72.6918 9.91759 72.5663 9.57898C72.5625 9.56885 72.5621 9.56632 72.5602 9.55654L72.5599 9.55488C72.5366 9.43142 72.5925 9.30558 72.7012 9.24033L73.0141 9.05264C73.1537 8.96887 73.3346 9.01095 73.4229 9.14774L80.5933 20.2549C80.735 20.4743 81.0695 20.4224 81.1381 20.1704L85.8041 3.0161C85.8845 2.72046 86.3033 2.7189 86.3859 3.01394L91.1919 20.1782C91.262 20.4287 91.595 20.479 91.7361 20.2605L98.9101 9.14774C98.9985 9.01095 99.1794 8.96887 99.319 9.05264L99.6318 9.24033C99.7407 9.30567 99.7965 9.43176 99.773 9.55538L99.7726 9.55749C99.7709 9.56654 99.7705 9.5689 99.7669 9.57857C99.6462 9.90776 95.2859 21.8189 93.7175 29.7957C92.2218 37.4025 91.6904 51.3467 91.6663 51.9964C91.6656 52.0171 91.6635 52.0303 91.6564 52.0498C91.6137 52.1684 91.5007 52.2492 91.3725 52.2492H86.242Z",
    fill: "white",
    fillOpacity: 0.04,
    style: {
      fill: "white",
      fillOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.509,
    cy: 8.14768,
    r: 1.50901,
    fill: "url(#paint4_linear_730_200069)",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.509,
    cy: 8.14768,
    r: 1.50901,
    fill: "url(#paint5_linear_730_200069)",
    fillOpacity: 0.85,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.509,
    cy: 8.14768,
    r: 1.50901,
    fill: "#FFC632",
    style: {
      fill: "#FFC632",
      fill: "color(display-p3 1.0000 0.7748 0.1958)",
      fillOpacity: 1,
      mixBlendMode: "color"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.509,
    cy: 8.14768,
    r: 1.50901,
    fill: "white",
    fillOpacity: 0.04,
    style: {
      fill: "white",
      fillOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.091,
    cy: 1.50901,
    r: 1.50901,
    fill: "url(#paint6_linear_730_200069)",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.091,
    cy: 1.50901,
    r: 1.50901,
    fill: "url(#paint7_linear_730_200069)",
    fillOpacity: 0.85,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.091,
    cy: 1.50901,
    r: 1.50901,
    fill: "#FFC632",
    style: {
      fill: "#FFC632",
      fill: "color(display-p3 1.0000 0.7748 0.1958)",
      fillOpacity: 1,
      mixBlendMode: "color"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.091,
    cy: 1.50901,
    r: 1.50901,
    fill: "white",
    fillOpacity: 0.04,
    style: {
      fill: "white",
      fillOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.9739,
    cy: 8.14768,
    r: 1.50901,
    fill: "url(#paint8_linear_730_200069)",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.9739,
    cy: 8.14768,
    r: 1.50901,
    fill: "url(#paint9_linear_730_200069)",
    fillOpacity: 0.85,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.9739,
    cy: 8.14768,
    r: 1.50901,
    fill: "#FFC632",
    style: {
      fill: "#FFC632",
      fill: "color(display-p3 1.0000 0.7748 0.1958)",
      fillOpacity: 1,
      mixBlendMode: "color"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.9739,
    cy: 8.14768,
    r: 1.50901,
    fill: "white",
    fillOpacity: 0.04,
    style: {
      fill: "white",
      fillOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.022 36.9C107.222 36.62 107.382 36.2867 107.502 35.9C107.622 35.5 107.682 35.08 107.682 34.64V25.36C107.682 24.92 107.622 24.5067 107.502 24.12C107.382 23.72 107.222 23.38 107.022 23.1V23H110.742V23.1C110.542 23.38 110.382 23.72 110.262 24.12C110.142 24.5067 110.082 24.92 110.082 25.36V36.54H112.622C113.436 36.54 114.109 36.4133 114.642 36.16C115.189 35.9067 115.636 35.56 115.982 35.12C116.329 34.6667 116.656 34.08 116.962 33.36H117.162L116.702 37H107.022V36.9ZM117.044 36.9C117.417 36.62 117.731 36.3 117.984 35.94C118.251 35.5667 118.484 35.1333 118.684 34.64L123.284 22.96H124.444L129.024 34.62C129.224 35.14 129.424 35.5667 129.624 35.9C129.824 36.2333 130.084 36.5667 130.404 36.9V37H126.144V36.9C126.384 36.6333 126.537 36.3 126.604 35.9C126.684 35.4867 126.631 35.0533 126.444 34.6L125.504 32.24H120.204L119.304 34.5C119.104 34.9933 119.051 35.4467 119.144 35.86C119.237 36.2733 119.444 36.62 119.764 36.9V37H117.044V36.9ZM120.364 31.78H125.344L122.864 25.4L120.364 31.78ZM132.101 36.9C132.301 36.62 132.461 36.2867 132.581 35.9C132.701 35.5 132.761 35.08 132.761 34.64V25.36C132.761 24.92 132.701 24.5067 132.581 24.12C132.461 23.72 132.301 23.38 132.101 23.1V23H137.541C138.861 23 140.061 23.2333 141.141 23.7C142.234 24.1667 143.114 24.92 143.781 25.96C144.447 27 144.781 28.3467 144.781 30C144.781 31.6533 144.447 33 143.781 34.04C143.114 35.08 142.234 35.8333 141.141 36.3C140.061 36.7667 138.861 37 137.541 37H132.101V36.9ZM137.121 36.52C138.134 36.52 139.021 36.28 139.781 35.8C140.541 35.32 141.134 34.5933 141.561 33.62C142.001 32.6467 142.221 31.44 142.221 30C142.221 28.5733 142.001 27.3733 141.561 26.4C141.134 25.4267 140.534 24.7 139.761 24.22C139.001 23.7267 138.121 23.48 137.121 23.48C136.507 23.48 135.854 23.58 135.161 23.78V36.22C135.867 36.42 136.521 36.52 137.121 36.52ZM149.788 36.9C149.988 36.62 150.148 36.2867 150.268 35.9C150.388 35.5 150.448 35.08 150.448 34.64V32.04L147.108 25.44C146.841 24.92 146.575 24.48 146.308 24.12C146.041 23.7467 145.741 23.4067 145.408 23.1V23H149.748V23.1C149.548 23.3667 149.428 23.7 149.388 24.1C149.361 24.5 149.461 24.9267 149.688 25.38L152.468 30.92L155.188 25.52C155.441 25.0133 155.555 24.5533 155.528 24.14C155.501 23.7267 155.348 23.38 155.068 23.1V23H157.808V23.1C157.421 23.3533 157.068 23.6533 156.748 24C156.441 24.3467 156.175 24.7467 155.948 25.2L152.848 31.28V34.64C152.848 35.08 152.908 35.5 153.028 35.9C153.148 36.2867 153.308 36.62 153.508 36.9V37H149.788V36.9Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_730_200069",
    x1: 0.00000299751,
    y1: 51,
    x2: 174.5,
    y2: 4.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A87F35",
    style: {
      stopColor: "#A87F35",
      stopColor: "color(display-p3 0.6588 0.4980 0.2078)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180201,
    stopColor: "#A87F35",
    style: {
      stopColor: "#A87F35",
      stopColor: "color(display-p3 0.6588 0.4980 0.2078)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409876,
    stopColor: "#FFDC62",
    style: {
      stopColor: "#FFDC62",
      stopColor: "color(display-p3 1.0000 0.8627 0.3843)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597465,
    stopColor: "#FFDC62",
    style: {
      stopColor: "#FFDC62",
      stopColor: "color(display-p3 1.0000 0.8627 0.3843)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758671,
    stopColor: "#A87F35",
    style: {
      stopColor: "#A87F35",
      stopColor: "color(display-p3 0.6588 0.4980 0.2078)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A87F35",
    style: {
      stopColor: "#A87F35",
      stopColor: "color(display-p3 0.6588 0.4980 0.2078)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_730_200069",
    x1: 84.241,
    y1: 14,
    x2: 84.241,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF6D1",
    style: {
      stopColor: "#FCF6D1",
      stopColor: "color(display-p3 0.9882 0.9647 0.8196)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#BD9457",
    style: {
      stopColor: "#BD9457",
      stopColor: "color(display-p3 0.7417 0.5822 0.3430)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E3CA89",
    style: {
      stopColor: "#E3CA89",
      stopColor: "color(display-p3 0.8902 0.7914 0.5373)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#FEE8C8",
    style: {
      stopColor: "#FEE8C8",
      stopColor: "color(display-p3 0.9958 0.9112 0.7842)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#4D3A1A",
    style: {
      stopColor: "#4D3A1A",
      stopColor: "color(display-p3 0.3000 0.2292 0.1013)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF0D1",
    style: {
      stopColor: "#FCF0D1",
      stopColor: "color(display-p3 0.9882 0.9410 0.8196)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_730_200069",
    x1: 74.0641,
    y1: 30.9114,
    x2: 100.348,
    y2: 27.2902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172016,
    stopColor: "#9EA1A1",
    style: {
      stopColor: "#9EA1A1",
      stopColor: "color(display-p3 0.6196 0.6314 0.6314)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45741,
    stopColor: "#848B8A",
    style: {
      stopColor: "#848B8A",
      stopColor: "color(display-p3 0.5176 0.5451 0.5412)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553567,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823421,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925155,
    stopColor: "#757A7B",
    style: {
      stopColor: "#757A7B",
      stopColor: "color(display-p3 0.4588 0.4784 0.4824)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_730_200069",
    x1: 87.06,
    y1: 48.1293,
    x2: 102.046,
    y2: 34.7296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_730_200069",
    x1: 71.1673,
    y1: 8.52626,
    x2: 73.982,
    y2: 7.86691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172016,
    stopColor: "#9EA1A1",
    style: {
      stopColor: "#9EA1A1",
      stopColor: "color(display-p3 0.6196 0.6314 0.6314)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45741,
    stopColor: "#848B8A",
    style: {
      stopColor: "#848B8A",
      stopColor: "color(display-p3 0.5176 0.5451 0.5412)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553567,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823421,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925155,
    stopColor: "#757A7B",
    style: {
      stopColor: "#757A7B",
      stopColor: "color(display-p3 0.4588 0.4784 0.4824)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_730_200069",
    x1: 72.6081,
    y1: 9.64887,
    x2: 73.5109,
    y2: 8.27628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_730_200069",
    x1: 84.7494,
    y1: 1.88759,
    x2: 87.564,
    y2: 1.22823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172016,
    stopColor: "#9EA1A1",
    style: {
      stopColor: "#9EA1A1",
      stopColor: "color(display-p3 0.6196 0.6314 0.6314)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45741,
    stopColor: "#848B8A",
    style: {
      stopColor: "#848B8A",
      stopColor: "color(display-p3 0.5176 0.5451 0.5412)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553567,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823421,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925155,
    stopColor: "#757A7B",
    style: {
      stopColor: "#757A7B",
      stopColor: "color(display-p3 0.4588 0.4784 0.4824)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_730_200069",
    x1: 86.1901,
    y1: 3.0102,
    x2: 87.0929,
    y2: 1.63761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_730_200069",
    x1: 98.6322,
    y1: 8.52626,
    x2: 101.447,
    y2: 7.86691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172016,
    stopColor: "#9EA1A1",
    style: {
      stopColor: "#9EA1A1",
      stopColor: "color(display-p3 0.6196 0.6314 0.6314)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45741,
    stopColor: "#848B8A",
    style: {
      stopColor: "#848B8A",
      stopColor: "color(display-p3 0.5176 0.5451 0.5412)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553567,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823421,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925155,
    stopColor: "#757A7B",
    style: {
      stopColor: "#757A7B",
      stopColor: "color(display-p3 0.4588 0.4784 0.4824)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576265",
    style: {
      stopColor: "#576265",
      stopColor: "color(display-p3 0.3412 0.3843 0.3961)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_730_200069",
    x1: 100.073,
    y1: 9.64887,
    x2: 100.976,
    y2: 8.27628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElite);
export default __webpack_public_path__ + "static/media/elite.71fca9a056428db76a39844c175fdfc3.svg";
export { ForwardRef as ReactComponent };